import { useNavigate, useSearchParams } from "react-router-dom";
import type { ProfilePreviewResponse } from "../../domain/types";
import { ProfilePreviewCard } from "../../components/ProfilePreviewCard";
import { getOnboardingContext } from "../../lib/onboardingStorage";
import { t } from "../../i18n";

export function OnboardingPreviewPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handle = searchParams.get("handle") ?? "";
  const data = getOnboardingContext().previewData;

  const preview: ProfilePreviewResponse = {
    availability: "public_available",
    reliabilityStatus: "reliable",
    profile: {
      handle,
      fullName: data?.fullName ?? undefined,
      profilePicUrl: data?.profilePicUrl ?? undefined,
      followersCount: data?.followersCount,
      followingCount: data?.followingCount,
    },
    previewFollowing: (data?.followings ?? []).map((following) => ({
      handle: following.username,
      fullName: following.fullName ?? undefined,
      profilePicUrl: following.profilePicUrl ?? undefined,
      gender:
        following.gender === "female" || following.gender === "male"
          ? following.gender
          : "unknown",
      genderSource: "UNKNOWN",
    })),
  };

  return (
    <div className="st-page st-preview-page st-onboarding-preview-page">
      <main className="st-section st-preview-results">
        <div className="st-container">
          <ProfilePreviewCard
            data={preview}
            ctaLabel={t("previewContinueToReview")}
            onStartMonitoring={() =>
              navigate(`/onboarding/review?handle=${encodeURIComponent(handle)}`)
            }
            onClose={() => navigate("/onboarding/target")}
          />
        </div>
      </main>
    </div>
  );
}
